import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { CanDeactivateGuard } from '@directives/can-deactivate/can-deactivate.guard';
import { AuthGuardService } from '@guards/auth-guard/auth-guard.service';
import { } from '@guards/rol-client-guard/rol-client.guard';
import { } from '@guards/rol-user-guard/rol-user.guard';
import { AsuntosComponent } from '@views/asuntos/asuntos/asuntos.component';
import { ConfiguracionComponent } from '@views/configuracion/configuracion/configuracion.component';
// import { EmpresaComponent } from '@views/configuracion/empresa/empresa.component';
import { DashboardComponent } from '@views/dashboard/dashboard/dashboard.component';
import { CreateDocumentComponent } from '@views/documentos/create-document/create-document.component';
import { DocumentosComponent } from '@views/documentos/documentos.component';
import { EditarDocumentoComponent } from '@views/documentos/editar-documento/editar-documento.component';
import { FormDocumentoComponent } from '@views/documentos/form-documento/form-documento.component';
import { BtnSendEmailComponent } from '@views/email/btn-send-email/btn-send-email.component';
import { InicioComponent } from '@views/inicio/inicio.component';
import { LoginComponent } from '@views/login/login/login.component';
import { PerfilUsuarioComponent } from '@views/perfil-usuario/perfil-usuario.component';
import { UsuariosComponent } from '@views/usuarios/listado-usuarios/usuarios.component';
import { ListadoMenuComponent } from '@views/seguridad/menus/listar-menu/listado-menu.component';
import { ListadoPermisoComponent } from '@views/seguridad/permisos/listar-permiso/listado-permiso.component';
import { ListadoCasoUsoComponent } from '@views/seguridad/casos-uso/listar-caso-uso/listado-caso-uso.component';
import { ListadoRolComponent } from '@views/seguridad/roles/listado-rol/listado-rol.component';
import { ListExpedienteComponent } from '@views/expedientes/list-expediente/list-expediente.component';
import { FormExpedienteCreateComponent } from '@views/expedientes/form-expediente-create/form-expediente-create.component';
import { FormExpedienteViewComponent } from '@views/expedientes/form-expediente-view/form-expediente-view.component';
import { FormExpedienteUpdateComponent } from '@views/expedientes/form-expediente-update/form-expediente-update.component';
import { ListAudienciaComponent } from '@views/audiencias/list-audiencia/list-audiencia.component';
import { ListCasoComponent } from '@views/casos/list-caso/list-caso.component';
import { ListTipoPericiaComponent } from '@views/tipos-pericia/list-tipo-pericia/list-tipo-pericia.component';
import { ListTareaComponent } from '@views/tareas/list-tarea/list-tarea.component';
import { FormPersonaViewComponent } from '@views/personas/form-persona-view/form-persona-view/form-persona-view.component';
import { FormJuzgadoViewComponent } from '@views/juzgados/form-juzgado-view/form-juzgado-view.component';
import { CreateEscritoComponent } from '@views/escritos/create-escrito/create-escrito.component';
import { MenuesDesplegablesComponent } from '@views/menues-desplegables/menues-desplegables.component';
import { ListTipoRegistroContableComponent } from '@views/tipos-registro-contable/list-tipo-registro-contable/list-tipo-registro-contable.component';
import { FormUsuarioRegistroComponent } from '@views/login/form-usuario-registro/form-usuario-registro.component';
import { FormVerificarCuentaUsuarioComponent } from '@views/login/form-verificar-cuenta-usuario/form-verificar-cuenta-usuario.component';
import { BienvenidaComponent } from '@views/login/bienvenida/bienvenida.component';
import { PrimerFactorComponent } from '@views/login/primer-factor/primer-factor.component';
import { RestablecerContrasenaComponent } from '@views/login/restablecer-contraseña/restablecer-contrasena.component';
import { RestablecerContrasenaTelefonoComponent } from '@views/login/restablecer-contraseña-telefono/restablecer-contrasena-telefono.component';
import { CambiarContrasenaComponent } from '@views/login/cambiar-contrasena/cambiar-contrasena.component';
import { NuevaContrasenaComponent } from '@views/login/nueva-contrasena/nueva-contrasena.component';
import { ListadoPersonasComponent } from '@views/personas/listado-personas/listado-personas.component';
import { FuerosComponent } from '@views/fueros/fueros.component';
import { ListMovimientoExpedienteComponent } from '@views/movimientos-expediente/list-movimiento-expediente/list-movimiento-expediente.component';
import { ListRegistroContableComponent } from '@views/registros-contable/list-registro-contable/list-registro-contable.component';
import { GenericTableComponent } from './component/generic-table/generic-table.component';
import { TableroKanbanComponent } from '@views/tareas/list-tarea/tablero-kanban-tareas/tableroKanban.component';
import { PlantillaEscritoComponent } from '@views/escritos/plantilla-escrito/plantilla-escrito/plantilla-escrito.component';
import { ListPlantillaEscritoComponent } from '@views/escritos/plantilla-escrito/list-plantilla-escrito/list-plantilla-escrito.component';
import { ListJuzgadosComponent } from '@views/juzgados/list-juzgado/list-juzgado.component';
import { FormViewTareaComponent } from '@views/tareas/form-view-tarea/form-view-tarea.component';
import { ListEscritoComponent } from '@views/escritos/list-escrito/list-escrito.component';
import { CargandoInicioAppComponent } from '@views/login/cargando-inicio-app/cargando-inicio-app.component';
import { DialogFormUsuarioComponent } from '@views/usuarios/dialog-form-usuario/dialog-form-usuario.component';
import { ListCalendarioJudicialComponent } from '@views/calendario-judicial/list-calendario-judicial/list-calendario-judicial.component';
import { ListadoPruebaTestimonialComponent } from '@views/pruebas/pruebaTestimonial/listado-prueba-testimonial/listado-prueba-testimonial.component';
import { ListadoPruebaInformativaComponent } from '@views/pruebas/pruebaInformativa/listado-prueba-informativa/listado-prueba-informativa.component';
import { DialogFormEscritoComponent } from '@views/escritos/dialog-form-escrito/dialog-form-escrito.component';
import { EscritosEditorComponent } from '@views/escrito-editor/escritos-editor/escritos-editor.component';

const routes: Routes = [

  { path: 'login', component: LoginComponent },
  { path: 'registrarse', component: FormUsuarioRegistroComponent },
  { path: 'verificarCorreo', component: FormVerificarCuentaUsuarioComponent },//ok
  { path: 'bienvenido', component: BienvenidaComponent },//ok
  { path: 'restablecerContrasena', component: RestablecerContrasenaComponent },//ok
  { path: 'restablecerContraTelefono', component: RestablecerContrasenaTelefonoComponent },//ok
  { path: 'primerFactor', component: PrimerFactorComponent },//ok
  { path: 'cambiarContrasena', component: CambiarContrasenaComponent },//ok
  { path: 'nuevaContrasena', component: NuevaContrasenaComponent },//ok
  {
    path: '', component: InicioComponent,
    canActivate: [AuthGuardService],
    data: {
      title: 'Inicio',
      breadcrumb: 'Inicio'
    },
    children: [
      {
        path: 'cargando',
        component: CargandoInicioAppComponent,
        canActivate: [AuthGuardService],
        data: {
        },
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuardService],
        data: {
          title: 'Dashboard',
          breadcrumb: {
            label: 'Dashboard',
          }


        },
      },
      {
        path: 'perfilUsuarios',
        component: PerfilUsuarioComponent,
        canActivate: [AuthGuardService],
        data: {
          title: 'Perfil de usuario',
          breadcrumb: 'Perfil Usuario'
        },
      },
      {
        path: 'configuracion',
        component: ConfiguracionComponent,
        canActivate: [AuthGuardService],
        data: {
          title: 'Configuración',
          breadcrumb: 'Configuración'
        },
      },
      {
        path: 'personas',
        canActivate: [AuthGuardService],
        data: {
          title: 'Personas',
          breadcrumb: 'Personas'
        },
        children: [
          {
            path: '',
            component: ListadoPersonasComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Listado de Personas',
              breadcrumb: 'Listado de Personas'
            }
          },
          {
            path: ':id',
            component: FormPersonaViewComponent,
            canActivate: [AuthGuardService],
            canDeactivate: [CanDeactivateGuard],
            data: {
              title: 'Ver',
              breadcrumb: 'Ver'
            },
          }
        ]
      },

      {
        path: 'usuarios',
        children: [
          {
            path: '',
            component: UsuariosComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Listado de Usuarios',
              breadcrumb: 'Listado de Usuarios'
            },
          },
        ]
      },
      {
        path: 'calendarioJudicial',
        component: ListCalendarioJudicialComponent,
        canActivate: [AuthGuardService],
        data: {
          title: 'Listado de Fechas de Eventos',
          breadcrumb: 'Listado de Fechas de Eventos'
        }
      },
      {
        path: 'asuntos',
        component: AsuntosComponent,
        canActivate: [AuthGuardService],
        data: {
          title: 'Listado de Asuntos',
          breadcrumb: 'Listado de Asuntos'
        }
      },
      {
        path: 'expedientes',
        children: [
          {
            path: '',
            component: ListExpedienteComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Listado de Expedientes',
              breadcrumb: 'Listado de Expedientes'
            },
          },
          {
            path: 'create',
            component: FormExpedienteCreateComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Nuevo',
              breadcrumb: 'Nuevo'
            },
          },
          {
            path: 'edit/:id',
            component: FormExpedienteUpdateComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Modificar',
              breadcrumb: 'Modificar'
            },
          },
          {
            path: ':id',
            component: FormExpedienteViewComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Ver',
              breadcrumb: 'Ver'
            },
          },
        ]
      },


      // {
      //   path: 'empresa',
      //   component: EmpresaComponent,
      //   canActivate: [AuthGuardService  ],
      //   data: {
      //     title: '',
      //     breadcrumb: [
      //       {
      //         label: 'Empresa',
      //         url: ''
      //       }
      //     ]
      //   },
      // },
      {
        path: 'fileupload',
        component: BtnSendEmailComponent,
        canActivate: [AuthGuardService],
        data: {
          breadcrumb: 'Enviar Correo'
        },
      },
      {
        path: 'documentos',
        component: DocumentosComponent,
        canActivate: [AuthGuardService],
        data: {
          title: 'Listado de Documentos',
          breadcrumb: 'Listado de Documentos'
        },
      },
      {
        path: 'documento',
        component: FormDocumentoComponent,
        canActivate: [AuthGuardService],
        data: {
          title: 'Documento',
          breadcrumb: 'Documento'
        },
        children: [
          {
            path: 'create',
            component: CreateDocumentComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Nuevo',
              breadcrumb: 'Nuevo'
            },
          },
          {
            path: 'edit/:id',
            component: EditarDocumentoComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Modificar',
              breadcrumb: 'Modificar'
            },
          },
          {
            path: ':id',
            component: EditarDocumentoComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Ver',
              breadcrumb: 'Ver'
            },
          }
        ]
      },
      {
        path: 'menues',
        component: ListadoMenuComponent,
        canActivate: [AuthGuardService],
        data: {
          title: 'Listado de Menus',
          breadcrumb: 'Listado de Menus'
        },
      },
      {
        path: 'permisos',
        component: ListadoPermisoComponent,
        canActivate: [AuthGuardService],
        data: {
          title: 'Listado de Permisos',
          breadcrumb: 'Listado de Permisos'
        },
      },
      {
        path: 'perfiles',
        component: ListadoCasoUsoComponent,
        canActivate: [AuthGuardService],
        data: {
          title: 'Listado de Perfiles',
          breadcrumb: 'Listado de Perfiles'
        },
      },
      {
        path: 'roles',
        component: ListadoRolComponent,
        canActivate: [AuthGuardService],
        data: {
          title: 'Listado de Roles',
          breadcrumb: 'Listado de Perfiles'
        },
      },
      {
        path: 'audiencias',
        children: [
          {
            path: '',
            component: ListAudienciaComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Listado de Audiencias',
              breadcrumb: 'Listado de Audiencias'
            },
          },
        ]
      },

      {
        path: 'casos',
        children: [
          {
            path: '',
            component: ListCasoComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Listado de Casos',
              breadcrumb: 'Listado de Casos'
            },
          },
        ]
      },
      {
        path: 'registroscontable',
        children: [
          {
            path: '',
            component: ListRegistroContableComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Listado de Registros Contable',
              breadcrumb: 'Listado de Registros Contable'
            },
          },

        ]
      },
      {
        path: 'tiposregistrocontable',
        children: [
          {
            path: '',
            component: ListTipoRegistroContableComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Listado de Tipos de Registros Contable',
              breadcrumb: 'Listado de Tipos de Registros Contable'
            },
          },

        ]
      },
      {
        path: 'tipospericia',
        children: [
          {
            path: '',
            component: ListTipoPericiaComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Listado de Tipos de Pericia',
              breadcrumb: 'Listado de Tipos de Pericias'
            },
          },

        ]
      },
      {
        path: 'juzgados',
        children: [
          {
            path: '',
            component: ListJuzgadosComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Listado de Juzgados',
              breadcrumb: 'Listado de Juzgados'
            },
          },
          {
            path: ':id',
            component: FormJuzgadoViewComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Ver',
              breadcrumb: 'Ver'
            },
          },


        ]
      },
      {
        path: 'fueros',
        children: [
          {
            path: '',
            component: FuerosComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Listado de Fueros',
              breadcrumb: 'Listado de Fueros'
            },
          },
        ]
      },
      {
        path: 'movimientoexpediente',
        children: [
          {
            path: '',
            component: ListMovimientoExpedienteComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Listado de movimientos de expediente',
              breadcrumb: 'Listado de movimientos de expediente'
            },
          },
        ]
      },
      {
        path: 'menusdesplegables',
        component: MenuesDesplegablesComponent,
        canActivate: [AuthGuardService],
        data: {
          title: 'Listado de Menus',
          breadcrumb: 'Listado de Menus'
        },
      },
      {
        path: 'tareas',
        children: [
          {
            path: '',
            component: ListTareaComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Listado de Tareas',
              breadcrumb: 'Listado de Tareas'
            },
          },
          {
            path: 'tablero',
            component: TableroKanbanComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Listado de Tareas',
              breadcrumb: 'Listado de Tareas'
            },
          },
          {
            path: ':id',
            component: FormViewTareaComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Ver tarea',
              breadcrumb: 'Ver tarea'
            },
          },

        ]
      },
      {
        path: 'escritos',
        children: [
          {
            path: '',
            component: ListEscritoComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Listado de Escritos',
              breadcrumb: 'Listado de Escritos'
            },
          },
          {
            path: 'nuevo',
            component: EscritosEditorComponent,//DialogFormEscritoComponent,//CreateEscritoComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Editar escritos',
              breadcrumb: 'Editar escritos'
            },
          },

        ]
      },

      {
        path: 'plantillas',
        canActivate: [AuthGuardService],
        data: {
          title: 'Listado de Platillas',
          breadcrumb: 'Listado de Platillas'
        },
        children: [
          {
            path: '',
            component: ListPlantillaEscritoComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Listado de Platillas',
              breadcrumb: 'Listado de Platillas'
            },
          },
          {
            path: 'create',
            component: PlantillaEscritoComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Nueva Plantilla',
              breadcrumb: 'Nueva Plantilla'
            },
          },

        ]
      },
      {
        path: 'pruebastestimonial',
        component: ListadoPruebaTestimonialComponent,
        canActivate: [AuthGuardService],
        data: {
          title: 'Prueba Testimonial',
          breadcrumb: 'Prueba Testimonial'
        },
      },

      {
        path: 'pruebasinformativa',
        component: ListadoPruebaInformativaComponent,
        canActivate: [AuthGuardService],
        data: {
          title: 'Prueba Informativa',
          breadcrumb: 'Prueba Informativa'
        },
      },

      {
        path: 'menusdesplegables',
        children: [
          {
            path: '',
            component: MenuesDesplegablesComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Menu Desplegables',
              breadcrumb: 'Menu Desplegables'
            },
          },
          {
            path: ':id',
            component: GenericTableComponent,
            canActivate: [AuthGuardService],
            data: {
              title: 'Ver',
              breadcrumb: 'Ver'
            },
          },

        ]
      },
      {
        path: "**", redirectTo: "/dashboard", pathMatch: 'full'
      }
    ]
  },


  {
    path: "**", redirectTo: "/dashboard", pathMatch: 'full'
  }
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, { useHash: true })
  ],
  exports: [RouterModule]

})
export class AppRoutingModule { }
